module.exports = __webpack_public_path__ + "static/media/closebtn.85c9184b.png";